import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import useDataKnisaLines from './Services/useDataKnisaLines'
import useGetKnisaLinesService from './Services/useGetKnisaLinesService'
import KnisotPageLayout from '../knisot/Components/KnisotPageLayout'
import { Surface, ScrollArea } from '../../../../generic/ui/Surface'
import KnisaLineRow from './Components/KnisaLineRow'
import { AppModal } from '../../../../generic/ui/Modal'
import { ScanBar } from '../../../../generic/ui/Input'
import DivideModal from '../miun/modal/DivideModal'
import ModalKnisaAddProduct from '../knisot/Create/Components/Modal/ModalKnisaAddProduct'
import KnisaLinesFilterButton from './Components/KnisaLinesFilterButton'

const KnisotLinesMain = () => {
  const [t] = useTranslation('knisa')

  const {
    knisaDetailsData,
    getKnisaLineByBarcode,
    getKnisotLinesByProduct,
    handleOpenDivideModal,
    divideModalP,
    isOpenDivideModal,
    addProductProps,
    selectedItem,
    handleControlProduct,
    isOpenProduct,
    detailsProps,
  } = useDataKnisaLines()

  const { products, growers, grower, setGrower, isGrower } = useGetKnisaLinesService()

  const isEmpty = !knisaDetailsData || knisaDetailsData.length < 1
  const lastIndex = (knisaDetailsData?.length ?? 0) - 1

  return (
    <KnisotPageLayout title='שורות כניסה'>
      {isOpenProduct && (
        <AppModal
          title={selectedItem ? t('knisa_create_modal_product_title_edit') : t('knisa_create_modal_product_title_create')}
          Children={ModalKnisaAddProduct}
          controlFunc={handleControlProduct}
          childrenProps={addProductProps}
        />
      )}
      {isOpenDivideModal && (
        <AppModal
          title={`${divideModalP.item?.EntryNum}-${divideModalP.item?.DetailNum} פיצול כניסה`}
          Children={DivideModal}
          childrenProps={divideModalP}
          controlFunc={handleOpenDivideModal}
        />
      )}

      <BarRow>
        <ScanBar onScan={getKnisaLineByBarcode} placeholder='ברקוד שורה' />
        <KnisaLinesFilterButton
          products={products}
          growers={growers}
          grower={grower}
          setGrower={setGrower}
          isGrower={isGrower}
          onSearch={getKnisotLinesByProduct}
        />
      </BarRow>

      <Surface>
        <ScrollArea>
          {isEmpty ? (
            <EmptyState>
              <img src='/images/no-data.png' alt='empty data' />
            </EmptyState>
          ) : (
            knisaDetailsData.map((d, i) => (
              <KnisaLineRow
                key={d.id ?? `${d.EntryNum}-${d.DetailNum}`}
                {...d}
                item={d}
                isLast={i === lastIndex}
                handleSelectItem={detailsProps.handleSelectItem}
                print={detailsProps.print}
                selectForDivide={detailsProps.selectForDivide}
                isOffice={detailsProps.isOffice}
              />
            ))
          )}
        </ScrollArea>
      </Surface>
    </KnisotPageLayout>
  )
}

export default KnisotLinesMain

const BarRow = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
`

const EmptyState = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
`
